import React, { useRef } from "react";
import { Box } from "@mui/material";
import Title from "./Title";
import Sentence from "./Sentence";
import image_1 from "../assets/img/ourstory/1.webp";
import image_2 from "../assets/img/ourstory/2.webp";
import image_3 from "../assets/img/ourstory/3.webp";
import image_4 from "../assets/img/ourstory/4.webp";
import image_5 from "../assets/img/ourstory/5.webp";
import image_6 from "../assets/img/ourstory/6.webp";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../assets/styles/OurStory.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/effect-coverflow";

import "antd/dist/reset.css";
import {
  FreeMode,
  Navigation,
  Thumbs,
  Pagination,
  Autoplay,
} from "swiper/modules";

const OurStory = () => {
  const swiperRef = useRef(null);
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);

  const allImages = [image_1, image_2, image_3, image_4, image_5, image_6];

  // const slidesSetting = {
  //   dots: false,
  //   infinite: true,
  //   slidesToShow: 6,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   speed: 600,
  //   autoplaySpeed: 3000,
  //   cssEase: "linear",
  //   pauseOnHover: false,
  //   pauseOnFocus: false,
  //   beforeChange: (currentSlide) => {
  //     swiperRef.current?.slideTo((currentSlide + 1) % allImages.length);
  //   },
  // };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ backgroundColor: "#fbf9f3" }} // 背景を白に設定
    >
      <Box
        sx={{
          padding: 4,
          display: "inline-block", // コンテンツに合わせて横幅を調整
          textAlign: "center",
          margin: "0 auto", // 親Boxを中央寄せ
        }}
      >
        <Title>Our story</Title>
        <Box sx={{ p: 2 }}></Box>

        <Box
          sx={{
            width: {
              xs: "300px", // スマホ (0px~)
              sm: "500px", // タブレット (~600px)
              md: "500px", // 小型デスクトップ (~900px)
              lg: "500px", // デスクトップ (~1200px)
              xl: "500px", // 大型デスクトップ (~無制限)
            },

            margin: "0 auto",
          }}
        >
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            loop={true}
            spaceBetween={30}
            effect={"coverflow"}
            speed={1000}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className="mySwiper"
            thumbs={{ swiper: thumbsSwiper }}
            modules={[Navigation, Thumbs, Pagination, Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            // pagination={{
            //   clickable: true,
            // }}
          >
            {allImages.map((image, index) => (
              <SwiperSlide>
                <Box key={index} sx={{ p: 0.5 }}>
                  <img
                    src={image}
                    alt={`Slide ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "2px",
                    }}
                  />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>

          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={0}
            slidesPerView={6}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Navigation, Thumbs]}
            className="mySwiper"
          >
            {allImages.map((image, index) => (
              <SwiperSlide>
                <Box key={index} sx={{ p: 0.5 }}>
                  <img
                    src={image}
                    alt={`Slide ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "2px",
                    }}
                  />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>

        <Box sx={{ m: 2 }}></Box>

        <Sentence>
          2022年2月某日
          <br />
          輝征が画面越しで見つけたのは
          <br />
          弾き語りをしている玲乃だった
        </Sentence>

        <Sentence>
          東京と名古屋という距離はあったものの
          <br />
          ”アニメが好き”という共通点で話題は尽きず
          <br />
          少しずつお互いを知っていった
        </Sentence>

        <Sentence>時は過ぎ_____</Sentence>

        <Sentence>2023年6月某日 交際がスタート</Sentence>

        <Sentence>
          １ヶ月後には同棲をし
          <br />
          次第に結婚を意識していくのであった
        </Sentence>

        <Sentence>
          そして交際から２年
          <br />
          2人は1つの苗字となった
        </Sentence>
      </Box>
    </Box>
  );
};

export default OurStory;
